<script lang="ts">
</script>

<div class="flex flex-col justify-items-center items-center mx-auto">
  <div class="shadow rounded bg-gray-50 w-11/12 content-center p-1">
    <div class="flex-1 m-4">
      <div class="inline-flex justify-items-center items-center min-w-full">
        <div class="mb:font-sm w-full">
          <p>■注意事項</p>
          <ul class="list-disc ml-4">
            <li>
              <p>
                いえのでんわ解約後も上記電話番号の継続利用を希望される場合、当月中に番号ポータビリティの手続きが必要になります
              </p>
            </li>
            <li>
              <p>乗換先の事業者へご連絡のうえ、番号ポータビリティをご申請ください</p>
            </li>
            <li>
              <p>
                <span class="warning">手続きが未完了のままいえのでんわを解約すると番号が廃止されます</span>
              </p>
            </li>
            <li>
              <p>乗換のお手続きの際には、電話番号の情報として以下の情報を申請ください</p>
            </li>
          </ul>
          <ul class="list-disc ml-8">
            <li>
              <p>移転元事業者名：アルテリア・ネットワークス株式会社</p>
            </li>
            <li>
              <p>サービス名：ＵＣＯＭ　光電話</p>
            </li>
          </ul>
          <ul class="list-none ml-4">
            <li>
              <p>
                ※「いえのでんわ」サービスはサービス提供は弊社ですが、設備提供事業者はアルテリア・ネットワークス株式会社となるため上記の通りの移転元事業者名/サービス名の申請が必要となりますのでご注意ください
              </p>
              <p>(この情報を誤って申請してしまうと乗換先事業者での手続きが完了しません)</p>
            </li>
          </ul>
          <ul class="list-disc ml-4">
            <li>
              <p>
                いえのでんわのご利用を開始する際に、新規に番号を発番した場合、NTTのアナログ回線への番号ポータビリティの手続きはできません
              </p>
            </li>
          </ul>

          <ul class="list-disc ml-4">
            <li>
              <p>
                でんわの利用の際に使用している専用のターミナルアダプタ等については、<span class="warning"
                  >解約月翌月20日必着</span
                >でご返却いただく必要があります。
              </p>
              <p>
                期日までの返却が確認できない場合、<span class="warning">弁済費(21,000円)</span
                >が必要となりますのでご注意ください
              </p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<style lang="postcss">
  p {
    @apply text-sm tracking-normal mb-1;
  }
  p > span.warning {
    @apply font-semibold text-red-400;
  }
</style>
